import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import Loader from "@/components/shared/Loader.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'OidcCallback',
  setup(__props) {

const store = useStore();
const router = useRouter();

onMounted(() => {
  store
    .dispatch("oidcStore/oidcSignInCallback", { useReplaceToNavigate: true })
    .then(async redirectPath => {
      const appInProgress = localStorage.getItem("appInProgress");

      if (appInProgress) {
        const appData = JSON.parse(appInProgress);

        await store.dispatch("setAppData", appData);
        router.push({ path: redirectPath, query: { lid: appData?.application?.lenderId, continue: "true" } });
      }
    })
    .catch(err => {
      console.error(err);
      router.push("/oidc-callback-error"); // Handle errors any way you want
    });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Loader, {
    stretch: true,
    inverse: true
  }))
}
}

})